<template>
  <div
    v-bind="$attrs"
    class="tw-container tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8"
  >
    <slot />
  </div>
</template>

<script setup></script>
